import { useState } from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

const SidebarGroup = ({ label, defaultOpen = true, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="mb-3">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between px-7 py-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white"
      >
        <span>{label}</span>
        {open ? (
          <MdExpandLess className="h-4 w-4" />
        ) : (
          <MdExpandMore className="h-4 w-4" />
        )}
      </button>
      {open ? <div className="mt-1">{children}</div> : null}
    </div>
  );
};

export default SidebarGroup;
